import { Injectable } from '@angular/core';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ChangeStatus } from './problem.service';

@Injectable({
  providedIn: 'root'
})
export class RootCauseFollowupService extends AbstractRestService {

  private clipboard:BehaviorSubject<any> = new BehaviorSubject<any>(null); // Use BehaviorSubject because we want to have a current value for new subscribers.

  private saveTrigger:Subject<boolean> = new Subject<boolean>(); // Use Subject because we don't want a current value for new subscribers.

  private changeStatus:BehaviorSubject<ChangeStatus> = new BehaviorSubject<ChangeStatus>(ChangeStatus.UNKNOWN);
  private changes:ChangeStatus[] = []; 

  postInit(): void {}

  setClipboard(value:any):void {
    this.clipboard.next(value);
  }

  getClipboard():Observable<any> {
    return this.clipboard.asObservable();
  }

  setChangeStatus(index:number, status:ChangeStatus):void {
    this.changes[index] = status;

    let maxValue:ChangeStatus = ChangeStatus.NO_CHANGES;

    this.changes.forEach( element => { maxValue = element > maxValue ? element : maxValue; });
    this.changeStatus.next(maxValue);
  }

  getChangeStatus():Observable<ChangeStatus> {
    return this.changeStatus.asObservable();
  }

  getSaveTrigger():Observable<boolean> {
    return this.saveTrigger.asObservable();
  }

  setSavetrigger(status:boolean):void {
    this.saveTrigger.next(status);
  }

  getRootCause(plant_name:string,): Observable<GenericLambdaReturn<any>> {
    let params:any={};

    params.PlantName = plant_name;

    return this.get({
      ApiResource: "/acknowledge/level1",
      data: params,
      repeatCall: false
    });
  }

  getFaultList(plant_name:string, root_cause:string, shift_start:string, shift_end:string): Observable<GenericLambdaReturn<any>> {
    let params:any={};

    params.PlantName = plant_name;
    params.RootCause = root_cause;
    params.ShiftStartDate = shift_start;
    params.ShiftEndDate = shift_end;

    return this.get({
      ApiResource: "/acknowledge",
      data: params,
      repeatCall: true,
      repeatRate: 120000
    });
  }

  acknowledge(fault:any, acknowledged:boolean, note:string): Observable<GenericLambdaReturn<any>> {
    let params:any={};

    params.ID = fault.ID;
    params.Comment = note;
    params.Acknowledged = acknowledged ? 1 : 0;

    params.Site = fault.Site;
    params.Environment = fault.Environment;
    params.ObjectID = fault.FaultObjectID;
    params.ShiftDate = fault.ShiftDate;
    params.Shift = fault.Shift;
    params.Hour = fault.Hour;
    params.FaultValue = fault.Occurrences > 1 ? fault.FaultValue : -1; // Don't pass FaultValue if just updating a single record
    params.FaultMessage = fault.FaultMessage;
    params.Source = fault.Source;

    return this.post({
      ApiResource: "/acknowledge",
      data: params,
      repeatCall: false
    });

  }
}
